/** Icônes hub (noms Icons.js) par clé de route métier. */
export const HEAD_DOCTOR_HUB_ICONS = {
  DOSSIER: 'history',
  CONSULTATIONS: 'stethoscope',
  PRESCRIPTIONS: 'pills',
  MALADIES: 'exclamationTriangle',
  ANALYSES: 'chartBar',
  RADIOGRAPHIES: 'shield',
  ECHOGRAPHIES: 'heart',
  PARTENAIRES: 'building',
  ORIENTATIONS: 'arrowRight',
  JOURS_REPOS: 'pause',
  VACCINS: 'shield',
  PLANIFICATION_FAMILIALE: 'users',
  SOINS_INFIRMERIE: 'heart',
  TESTS_INFIRMERIE: 'check',
  INJECTION_INFIRMERIE: 'syringe',
  RENDEZ_VOUS: 'calendar',
  STATISTIQUES: 'chartBar',
  newConsult: 'plus'
};

export function getHeadDoctorHubIcon(def) {
  if (def.kind === 'newConsult') return HEAD_DOCTOR_HUB_ICONS.newConsult;
  return HEAD_DOCTOR_HUB_ICONS[def.routeKey] || 'chartBar';
}
